import { render, staticRenderFns } from "./ParkingSpaces.vue?vue&type=template&id=73d90107&scoped=true"
import script from "./ParkingSpaces.vue?vue&type=script&lang=js"
export * from "./ParkingSpaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d90107",
  null
  
)

export default component.exports